<mat-card appearance="outlined" class="policy-mat-card">
    <mat-card-content *transloco="let t">
        <div [innerHtml]="t('Privacy.Content')"></div>
    </mat-card-content>
</mat-card>
